import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const MScComputerScience = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px', marginTop: '160px',marginLeft:'50px' }}>
      <h1 style={{ textAlign: 'center' }}>📘 MSc in Computer Science</h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The MSc in Computer Science program at Admas University is designed to equip students with advanced knowledge in computing, software development, and research methodologies. It focuses on preparing graduates to solve real-world problems through innovative computing solutions and contribute meaningfully to the technology sector in Ethiopia and beyond.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To build a strong foundation in computer science theory and advanced algorithms.</li>
          <li>To develop high-level skills in software development, AI, and data science.</li>
          <li>To encourage research and innovation in emerging technologies like machine learning and cloud computing.</li>
          <li>To train professionals who can contribute to the growth of Ethiopia’s digital economy.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Core Courses</h2>
        <ul>
          <li>Advanced Algorithms and Data Structures</li>
          <li>Artificial Intelligence & Machine Learning</li>
          <li>Advanced Database Systems</li>
          <li>Research Methodology in Computer Science</li>
          <li>Software Engineering and Design Patterns</li>
          <li>Computer Networks & Cybersecurity</li>
          <li>Cloud Computing and Distributed Systems</li>
          <li>Big Data Analytics</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Bachelor’s degree in Computer Science, Software Engineering, Information Systems, or related field.</li>
          <li>Minimum GPA as required by the Ministry of Education or the university’s graduate admissions committee.</li>
          <li>Passing score on the university’s entrance exam for postgraduate study.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          Graduates of the MSc in Computer Science can pursue careers as software engineers, data scientists, AI specialists, system analysts, IT consultants, or academic researchers in universities and tech-based organizations locally and internationally.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Choose Admas University?</h2>
        <ul>
          <li>Experienced academic staff with industry knowledge.</li>
          <li>Flexible weekend and evening classes for working professionals.</li>
          <li>Affordable tuition and scholarship opportunities.</li>
          <li>Modern computing labs and research support.</li>
        </ul>
      </section>
    </div>
  );
};

export default MScComputerScience;